import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var router = new Router({
    // scrollBehavior() {
    //     return { x: 0, y: 0 };
    // },    
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/home',
        },

        {
            path: '/offline',
            name: 'offline',
            component: function () { 
                return import('@/components/Home/Offline.vue')
            },
            meta: { layout: 'default', footer: true }
        },

        {
            path: '/home',
            name: 'home',
            component: function () { 
                return import('@/components/Home/Layout.vue')
            },
            meta: { layout: 'default', footer: true }
        },

        {
            path: '/login',
            name: 'login',
            component: function () { 
                return import('@/components/Auth/Login.vue')
            },
            meta: { layout: 'blank' }
        },

        {
            path: '/register',
            name: 'register',
            component: function () { 
                return import('@/components/Auth/RegisterStatic.vue')
            },
            meta: { layout: 'blank' }
        },        

        {
            path: '/search',
            name: 'search',
            component: () => { 
                return import('@/components/Search/Layout.vue')
            },
            meta: { layout: 'default', footer: true }
        },    

        {
            path: '/messages',
            name: 'messages',
            component: function () { 
                return import('@/components/Messages/Layout.vue')
            },
            meta: { layout: 'default', footer: true }
        },

        {
            path: '/playlist/:playlistId',
            name: 'playlist',
            component: function () { 
                return import('@/components/Playlists/Layout.vue')
            },
            props: true,
            meta: { layout: 'default', footer: true }
        },

         {
            path: '/song/:songId',
            name: 'song',
            component: function () { 
                return import('@/components/Song/Layout.vue')
            },
            props: true,
            meta: { layout: 'default', footer: true }
        },

        {
            path: '/profile/:uid?',
            name: 'profile',
            component: function () { 
                return import('@/components/Profile/Layout.vue')
            },
            props: true,
            meta: { layout: 'default', footer: true }
        },
    ], 
})

router.beforeEach((to, from, next) => {

    if (!navigator.onLine && to.name != 'offline'){
        localStorage.offlineUrl = to.path;
        next('/offline');
        return;
    }

    if (navigator.onLine && to.name == 'offline'){
        next('/home');
        return;        
    }

    $('main').scrollTop(0);
    var isAuth = true;

    //check if not loggedin and is not on login/register
    if ( ['login', 'register', 'offline'].indexOf(to.name) == -1 ){
        if (localStorage.getItem('appuser') && localStorage.getItem('token')){

            //check jwt token
            try {
                var tkn = jwtDecode(localStorage.getItem('token'));
                if ( tkn.exp < Date.now() / 1000 ) {
                    isAuth = false;
                }else{
                    window.App.jwt = tkn;
                    App.user = JSON.parse(localStorage.getItem('appuser'));
                }
            } catch(e) {
                isAuth = false;
            }

        }else{
           isAuth = false;
        }
    }


    /// IS GUEST access required ? 
    if ( ['song-guest', 'profile-guest', 'playlist-guest'].indexOf(to.name) != -1 ){
        if (isAuth){
            switch (to.name){
                case 'song-guest': next(`/song/${to.params.id}`); return;
                case 'profile-guest': next(`/profile/${to.params.id}`); return;
                case 'playlist-guest': next(`/playlist/${to.params.id}`); return;
            }
        }else{
            if (!App.jwt){
                if (to.query.token){
                    App.jwt = to.query.token;
                    switch (to.name){
                        case 'song-guest': next(`/song/${to.params.id}/unauthenticated`); return;
                        case 'profile-guest': next(`/profile/${to.params.id}/unauthenticated`); return;
                        case 'playlist-guest': next(`/playlist/${to.params.id}/unauthenticated`); return;
                    }
                }else{
                    next('/login'); return;
                }
            }else{
                next();return;
            }
        }
    }

    if (to.name == 'register'){
        next();
        return;
    }
 
    if (isAuth == false){
        next('/login');
        return;
    }

    if (to.name == from.name && (to.hash == from.hash || JSON.stringify(to.params) != JSON.stringify(from.params) )){
        if (Event.$root) Event.$root.$emit('forcePageReload'); console.log(1);
    }

    if (to.path != '/search'){
        if (Event.$root) Event.$root.$emit('clearSearch');  console.log(2);
    }

    if ((App.filters === false && ['login', 'register'].indexOf(to.name) == -1) || from.name == 'login'){
        if (Event.$root) Event.$root.$emit('appNotReady');  console.log(from.name, to.name);
    }

    next(); 
})

// router.replace({ path: '*', redirect: '/home' })
export default router;